import {
  logo_inline_w
} from "../../constants/GlobalConst";

export const selectedIcon = {
  dashboard:
      "/assets/images/aside/gmd_menu_01_on@3x.png",
  campaign:
      "/assets/images/aside/gmd_menu_02_on@3x.png",
  notice:
      "/assets/images/aside/gmd_menu_03_on@3x.png",
  inquiry:
      "/assets/images/aside/gmd_menu_03_on@3x.png",
  reports:
      "/assets/images/aside/gmd_menu_04_on@3x.png",
  settings:
      "/assets/images/aside/gmd_menu_05_on@3x.png",
  platform:
      "/assets/images/aside/gmd_menu_06_on@3x.png"
};

export const menuList = [
  {
    name: "dashboard",
    group: "main",
    groupLabel: "메인",
    header: "대시보드",
    include: [
      "dashboard"
    ],
    child: []
  },
  {
    name: "campaign",
    group: "main",
    header: "광고관리",
    include: [
      "campaign",
      "manageCreative",
      "manageCreativeDetail",
      "campaignLookOver",
      "campaignTwo",
      "campaignThree",
      "campaignFour",
      "bannerCreative",
      "audioCreative"
    ],
    child: [
      {
        name: "campaign",
        header: "캠페인 생성"
      },
      {
        name: "manageCreative",
        header:
            "캠페인 및 소재 관리",
        detail:
            "manageCreativeDetail",
        details: [
          "campaignLookOver",
          "campaignTwo",
          "campaignThree",
          "campaignFour"
        ]
      }
    ]
  },
  {
    name: "reports",
    group: "main",
    header: "보고서",
    include: [
      "reportsPeriod",
      "reportsPeriodHour",
      "reportsAdver",
      "reportsCampaign",
      "reports",
      "customReports"
    ],
    child: [
      {
        name:
            "reportsPeriod",
        header:
            "기간별 보고서"
      },
      {
        name:
            "reportsPeriodHour",
        header:
            "시간대별 보고서"
      },
      {
        name:
            "reportsAdver",
        header:
            "광고주별 보고서"
      },
      {
        name:
            "reportsCampaign",
        header:
            "캠페인별 보고서"
      },
      {
        name: "reports",
        header: "보고서 생성"
      },
      {
        name:
            "customReports",
        header:
            "커스텀 보고서"
      }
    ]
  },
  {
    name: "settings",
    group: "manage",
    groupLabel: "관리",
    header: "설정",
    include: [
      "budgetTime",
      "settings",
      "settingsDetail",
      "budgetEvent",
      "budgetEventDetail",
      "budgetTimeDetail",
      "budgetTimeList"
    ],
    child: [
      {
        name: "settings",
        header:
            "시간별 예산 관리",
        detail:
            "budgetTimeList",
        detail2:
            "budgetTimeDetail"
      }
    ]
  },
  {
    name: "platform",
    group: "manage",
    header: "플랫폼 관리",
    include: [
      "platform",
      "platformDetail",
      "platformAdmin",
      "categoryManage",
      "productManage",
      "historyCampaignManage",
      "historyPriceManage",
      "historyEventManage",
      "historyTimeManage",
      "historyCampaignDetail",
      "historyPriceDetail",
      "historyEventDetail",
      "historyTimeDetail",
      "conversionManage",
      "paymentManage",
      "advertisingPayments",
      "regionManage",
      "platformTerm",
      "platformTermDetail"
    ],
    child: [
      {
        name: "platform",
        header: "사용자 관리",
        detail:
            "platformDetail"
      },
      {
        name:
            "platformAdmin",
        header: "관리자 관리",
        detail:
            "platformAdmin"
      },
      {
        name:
            "paymentManage",
        header: "결제 관리"
      },
      {
        name:
            "advertisingPayments",
        header: "포인트 관리"
      },
      {
        name: "regionManage",
        header: "지역 관리"
      },
      {
        name:
            "platformTerm",
        header: "약관 관리",
        detail:
            "platformTermDetail"
      }
    ]
  },
  {
    name: "notice",
    group: "support",
    groupLabel: "지원",
    header: "공지사항",
    include: [
      "notice",
      "noticeDetail"
    ],
    child: []
  },
  {
    name: "inquiry",
    group: "support",
    header: "도움말",
    include: [
      "inquiry",
      "inquiryDetail"
    ],
    child: []
  }
];

export const narrowStyle = {
  li: {
    marginLeft: 8,
    marginRight: 8,
    borderRadius: 8
  },
  icon: {
    backgroundImage:
        `url(${logo_inline_w})`,
    width: 40,
    backgroundPosition:
        "center"
  },
  button: {
    transform:
        "rotate(180deg)"
  }
};

export const widenStyle = {
  li: {
    marginLeft: 0,
    marginRight: 0
  },
  icon: {
    backgroundImage:
        `url(${logo_inline_w})`,
    width: 148
  }
};

export const ROLE = {
  NORMAL: "NORMAL",
  ADMIN: "ADMIN",
  SUPER_ADMIN: "SUPER_ADMIN"
};

export const NORMAL_MAIN_MENU_NAMES = [
  "reports",
  "dashboard",
  "notice"
];

export const NORMAL_CHILD_MENU_NAMES = [
  "reports",
  "reportsPeriodHour",
  "reportsPeriod",
  "reportsAdver",
  "reportsCampaign",
  "account",
  "accountHistory"
];

export const ADMIN_BLOCKED_CHILD_NAMES = [
  "accountProfile",
  "platformAdmin",
  "platformTerm"
];

export const SUPER_ADMIN_BLOCKED_CHILD_NAMES = [
  "accountProfile"
];

export const DEFAULT_REPORT_LINKS = [
  {
    id: "reports",
    label: "보고서 생성",
    path: "/board/reports",
    groupBy: null
  },
  {
    id: "reportsPeriod",
    label: "일자별 보고서",
    path:
        "/board/reportsPeriod",
    groupBy: "BY_DAILY"
  },
  {
    id:
        "reportsPeriodHour",
    label:
        "시간대별 보고서",
    path:
        "/board/reportsPeriodHour",
    groupBy: "BY_HOURLY"
  },
  {
    id: "reportsAdver",
    label:
        "광고주별 보고서",
    path:
        "/board/reportsAdver",
    groupBy: "BY_DAILY"
  }
];
